export const setPromise = (item) => ({
  type: "Payload_role",
  payload: item,
});


